import { ReactElement } from 'react';

import { useDentistsContext } from '..';
import { Button } from '../../Button';
import { RefreshIcon } from '../../icons/RefreshIcon';

interface Props {
  total: number;
}

const toUpperText = (value: any) =>
  typeof value === 'string' ? value.toLocaleUpperCase('pt-BR') : value || '';

export default function InfoBox({ total }: Props): ReactElement {
  const {
    state,
    city,
    specialty,
    bairro,
    bairros,
    cep,
    loading,
    handleRefresh,
    editSearch,
  } = useDentistsContext();
  const bairroSelecionado = bairros.find(b => String(b.Id) === String(bairro));
  const cityName = (city as any)?.Nome || (city as any)?.Descricao;

  return (
    <div className="mt-5 w-full rounded-lg bg-neutral-surface p-5">
      <div className="flex flex-wrap items-end justify-between gap-5">
        <div className="flex flex-wrap gap-2">
          <Button
            text="Alterar filtros"
            intent="secondary"
            onClick={editSearch}
          />
          <button
            className="flex h-12 items-center gap-2 rounded-lg px-4 text-sm font-bold uppercase text-primary-main hover:bg-primary-container disabled:opacity-50"
            onClick={handleRefresh}
            disabled={loading}
          >
            <RefreshIcon />
            {loading ? 'ATUALIZANDO' : 'ATUALIZAR LISTA'}
          </button>
        </div>

        <div className="flex flex-wrap gap-5">
          <div>
            <p className="text-xs font-bold uppercase text-medium-emphasis">
              REGIAO
            </p>
            <p className="text-base text-high-emphasis">
              {toUpperText(cityName)}
              {state?.Sigla ? ` - ${toUpperText(state.Sigla)}` : ''}
            </p>
          </div>

          {bairroSelecionado && (
            <div>
              <p className="text-xs font-bold uppercase text-medium-emphasis">
                BAIRRO
              </p>
              <p className="text-base text-high-emphasis">
                {toUpperText(bairroSelecionado.Nome)}
              </p>
            </div>
          )}

          {cep && (
            <div>
              <p className="text-xs font-bold uppercase text-medium-emphasis">
                CEP
              </p>
              <p className="text-base text-high-emphasis">{toUpperText(cep)}</p>
            </div>
          )}

          <div>
            <p className="text-xs font-bold uppercase text-medium-emphasis">
              ESPECIALIDADE
            </p>
            <p className="text-base text-high-emphasis">
              {toUpperText(specialty?.nomeEspecialidade)}
            </p>
          </div>

          <div>
            <p className="text-xs font-bold uppercase text-medium-emphasis">
              ENCONTRADOS
            </p>
            <p className="text-base font-semibold text-primary-main">
              {loading ? '...' : total}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
